import { Button } from "primereact/button";
import { Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { AccountsTable } from "./parts/accounts-table";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";
import { Paths } from "../../routes/paths";

export const AccountsScreen = () => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	const handleCreateAccountOnClick = () => {
		navigate(Paths.accounts.withId("new").edit.path);
	};

	const canModify = useHasPermissions(["UserInAccountPermission_AuthAdmin_Modify"]);
	const canRead = useHasPermissions(["UserInAccountPermission_AuthAdmin_Read"]);

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("common:accounts.title")}>
			{canModify && (
				<Button
					label={t("common:accounts.createAccount")}
					onClick={handleCreateAccountOnClick}
				/>
			)}
			<Suspense fallback={<div>{t("common:general.loading")}</div>}>
				<AccountsTable />
			</Suspense>
		</BaseScreen>
	);
};
